module.exports = __webpack_public_path__ + "static/media/LINE_Icon.15ace046.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/LINE_Icon.png
// module id = 3300
// module chunks = 0